module.exports = __webpack_public_path__ + "media/sofia/sofia-selection-2d7e69c8.png";